import apiClient from 'ps-components/lib/apiClient';
import { IRegressionSourceReturn, IRegressionJobReturn, IRegressionJobParams, IRegressionDatacutParams, IRegressionDatacutReturn, IRegressionMatchReturn, IRegressionMatchParams } from './types/regression';

export async function getRegressionSurveySources(masterAccountId: string | number, params: { currency: string}): Promise<IRegressionSourceReturn> {
  return (
    await apiClient.apiGet(`/cms/api/accounts/${masterAccountId}/regression/sources`, { params })
  ).data;
}

export async function getRegressionSurveyJobs(masterAccountId: string | number, params: IRegressionJobParams): Promise<IRegressionJobReturn> {
  return (
    await apiClient.apiGet(`/cms/api/accounts/${masterAccountId}/regression/jobs`, { params })
  ).data;
}

export async function getRegressionSurveyDatacuts(masterAccountId: string | number, params: IRegressionDatacutParams): Promise<IRegressionDatacutReturn> {
  return (
    await apiClient.apiGet(`/cms/api/accounts/${masterAccountId}/regression/datacuts`, { params })
  ).data;
}

export async function getRegressionSurveyMatches(params: IRegressionMatchParams): Promise<IRegressionMatchReturn> {
  return await apiClient.apiGet('/pricing2/regression-jobs', { params }, { useMerit: true });
}

export async function saveRegressionSurveyMatches(params: any): Promise<IRegressionMatchReturn> {
  return await apiClient.apiPost('/pricing2/regression-jobs', params, { useMerit: true });
}

export async function submitRegressionSurveyMatches(params: any): Promise<IRegressionMatchReturn> {
  return await apiClient.apiPost('/pricing2/regression-jobs-match', params, { useMerit: true });
}